import http from "../http-common";

class ExaminerService {
  createExaminer(data) {
      return http.post(`/api/examiner`, data);
    }
  getExaminers(year,term,exam_type) {
    return http.get(`/api/examiner?year=`+year+'&&term='+term+'&&exam_type='+exam_type);
  }
  getExaminerByFilter(data) {
    return http.get(`/api/examiner/getExaminerByFilter?examination_schedule_id=`+data.examination_schedule_id+'&&proctor_id='+data.proctor_id);
  }
  getExaminer(id) {
    return http.get(`/api/examiner/`+id);
  }
  updateExaminer(id, data) {
    return http.put(`/api/examiner/${id}`, data);
  }
}

export default new ExaminerService();